import script from "./SwitchNetwork.vue?vue&type=script&setup=true&lang=ts"
export * from "./SwitchNetwork.vue?vue&type=script&setup=true&lang=ts"

import "./SwitchNetwork.vue?vue&type=style&index=0&id=97f3d4e8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97f3d4e8"]])

export default __exports__